import { Flex, RemoteImage } from '@banhala/ui-kit';

const SLOT_COUNT = 3;

interface ThreeImageHeaderProps {
  images: string[];
  cardWidth: number;
}

export const ThreeImageHeader = ({
  images,
  cardWidth,
}: ThreeImageHeaderProps) => {
  const imageWidth = (cardWidth - 4) / 3;
  const imageHeight = imageWidth * 1.2;

  return (
    <Flex.Row height={imageHeight} gap={2}>
      {Array.from({ length: SLOT_COUNT }, (_, index) => {
        const uri = images[index];
        return uri ? (
          <RemoteImage
            key={index}
            uri={uri}
            width={imageWidth}
            height={imageHeight}
          />
        ) : (
          <Flex key={index} width={imageWidth} height={imageHeight} />
        );
      })}
    </Flex.Row>
  );
};
